export default (param) => {
  if (param === '' || param === null || param === 'null' || param === undefined || param === 'undefined' || param.length === 0) {
    return false;
  }

  return true;
};

